"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getApiHostForEnviroment;

var _enviro = _interopRequireDefault(require("enviro"));

function getApiHostForEnviroment() {
  switch (_enviro.default.getShort('filemanager')) {
    case 'local':
      return 'local.hubspotqa.com';

    case 'prod':
      return 'api.hubspot.com';

    case 'qa':
    default:
      return 'api.hubspotqa.com';
  }
}

module.exports = exports.default;